<template>
  <div class="radar-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
      <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
      <!--数据/图例设置-->
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')" name="2" class="paddingtb8">
        <template slot="title">
          <div class="tabs flex" :class="request_prefix === 'bigScreen' ? '' : 'home_tabs'">
            <div :class="tabsActive == 0 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 0)">
              数据组
            </div>
            <div :class="tabsActive == 1 ? 'tabs-item active' : 'tabs-item'" @click="changeActiveHandle($event, 1)">
              图例
            </div>
          </div>
        </template>
        <div class="setting-item" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <template v-if="tabsActive == 0">
            <numberSetting :options="options" :ids="ids"></numberSetting>
            <div v-for="(item, index) in seriesData" :key="index">
              <collapsibleItem>
                <div slot="heading">{{ item.name }}</div>
                <div slot="body">
                  <RadarSeriesSetting
                    :options="options"
                    :seriesSettingItem="item"
                    :ids="ids"
                    :index="index"
                    ref="seriesSetting"
                  ></RadarSeriesSetting>
                </div>
              </collapsibleItem>
            </div>
          </template>
          <template v-else>
            <legend-setting :options="options" :ids="ids"></legend-setting>
          </template>
        </div>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')" name="3" title="角度轴">
        <template slot="title">
          角度轴
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialogClick(1)"></i>
        </template>
        <template v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <div class="mb8">文字样式</div>
          <div class="mt16">
            <!-- 字体和颜色/字重和字号 -->
            <text-setting-update
                class=""
                :fontColor.sync="axisFontColor"
                :colorArr.sync="axisFontColor"
                :fontFamily.sync="axisFontFamily"
                :fontSize.sync="axisFontSize"
                :fontWeight.sync="axisFontWeight"
            />

          </div>
          <div class="mt16">
            <div class="mt16">
              <div class="mb8">文字距离</div>
              <div class="verticallyCenter">
                <el-slider
                  :show-tooltip="false"
                  class="mr16 percent54 height4"
                  v-model="axisNameGap"
                  :min="0"
                  :step="1"
                  :max="50"
                ></el-slider>
                <div class="number-input-box percent46_16">
                  <single-input
                    class="percent100"
                    :value.sync="axisNameGap"
                    inputSuffixs="px"
                    :min="0"
                    :step="1"
                    :max="50"
                  />
<!--                  <el-input-->
<!--                    class="percent100"-->
<!--                    v-model="axisNameGap"-->
<!--                    placeholder="请输入"-->
<!--                    :controls="false"-->
<!--                    :min="0"-->
<!--                    :step="1"-->
<!--                    :max="50"-->
<!--                    type="number"-->
<!--                    v-inputHandle="{ this1, type: 'axisNameGap' }"-->
<!--                  >-->
<!--                    <template slot="suffix">-->
<!--                      <span class="suffix_text">px</span>-->
<!--                    </template>-->
<!--                  </el-input>-->
                </div>
              </div>
              <color-picker :color.sync="axisLineColor" titlePosition="allInOneLine" title="填充颜色" class="mt16" />
              <slider-and-input
                class="mt16"
                v-if="checkType(axisLineWidth)"
                :value.sync="axisLineWidth"
                title="轴线粗细"
                :sliderMin="0"
                :sliderMax="30"
                suffix="px"
              />
            </div>
          </div>
          <el-checkbox class="mt16" v-model="showMaxLabel">显示最大值</el-checkbox>
          <div class="mt16" v-if="showMaxLabel">
            <!-- 字体和颜色/字重和字号 -->
            <text-setting-update
                class="mb16 nextlinemt8"
                :fontColor.sync="maxLabelFontColor"
                :fontFamily.sync="maxLabelFontFamily"
                :fontSize.sync="maxLabelFontSize"
                :fontWeight.sync="maxLabelFontWeight"
            />
            <div class="mt16 verticallyCenter">
              <span class="mr12">单位</span>
              <el-input v-model="maxLabelUnit" placeholder="请输入" class="unit-ipt flex1"></el-input>
            </div>
          </div>
        </template>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')" name="4" title="辅助线">
        <template v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <el-checkbox v-model="splitShow">显示分割线</el-checkbox>
          <div class="mt16 verticallyCenter">
            <label class="font14 inlineMiddle mr16">分割线形状</label>
            <el-select v-model="shape" class="percent65 height32" ref="">
              <el-option
                v-for="(item, index) in shapeStyleList"
                :key="index"
                :selected="shape == item.value"
                :value="item.value"
                :label="item.title"
                >{{ item.title }}
              </el-option>
            </el-select>
          </div>
          <div class="mt16 mb16">线条样式</div>
          <line-setting
            :lineName.sync="splitLineType"
            :lineWidth.sync="splitLineWidth"
            :lineColor.sync="splitLineColor"
          />
          <el-checkbox v-model="splitAreaShow" class="mt16 mb16">显示分割区域</el-checkbox>
          <div class="verticallyCenter">
            <span class="mr8">分割段数</span>
            <single-input
              class="percent100 flex1"
              :value.sync="splitNumber"
              inputSuffixs="段"
              :min="0"
              :step="1"
              :max="30"
            />
<!--            <el-input-->
<!--              class="percent100 flex1"-->
<!--              v-model="splitNumber"-->
<!--              placeholder="请输入"-->
<!--              :controls="false"-->
<!--              :min="0"-->
<!--              :step="1"-->
<!--              :max="30"-->
<!--              type="number"-->
<!--              v-inputHandle="{ this1, type: 'splitNumber' }"-->
<!--            >-->
<!--              <template slot="suffix">-->
<!--                <span class="suffix_text">段</span>-->
<!--              </template>-->
<!--            </el-input>-->
          </div>
          <!--          -->
          <!--          <slider-and-input-->
          <!--            class="mt16"-->
          <!--            v-if="checkType(splitNumber)"-->
          <!--            :value.sync="splitNumber"-->
          <!--            title="分割段数"-->
          <!--            :sliderMin="0"-->
          <!--            :sliderMax="30"-->
          <!--            suffix="段"-->
          <!--          />-->
          <div class="mt16">
            <span>分割区域颜色</span>
            <span class="icon-portal-plus theme-color right-icon area-add-icon" @click="addAreaColor"></span>
            <div
              class="single_bg mt16"
              v-for="(rich, key) in areaColorList"
              :key="key"
              @dragover.prevent
              @drop="stopChangePosition(rich, key, $event)"
            >
              <div class="single_color_icons">
                <color-picker @change="changeRichColor(rich, key, $event)" :color="rich" class="percent78" />
                <div class="icon_set move-icon">
                  <img :src="Vector" draggable="true" @dragstart="startChangePosition(rich, key, $event)" />
                </div>
                <div class="icon_set del-icon">
                  <span @click="delRchSingleColor(rich, key)" class="icon-portal-delete" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-collapse-item>
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')" name="5" title="边距">
        <template v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')">
          <div class="mb16" v-if="checkType(position1)">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="position1"
              title="距离左边框"
              titlePosition="singleLine"
              :sliderMax="100"
              suffix="%"
            />
          </div>
          <div class="mb16" v-if="checkType(position2)">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="position2"
              title="距离上边框"
              titlePosition="singleLine"
              :sliderMax="100"
              suffix="%"
            />
          </div>
          <div class="mb16" v-if="checkType(radius1)">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="radius1"
              title="内环占比"
              titlePosition="singleLine"
              :sliderMax="100"
              suffix="%"
            />
          </div>
          <div v-if="checkType(radius2)">
            <slider-and-input
              inputWidth="small"
              inputHeight="small"
              :value.sync="radius2"
              title="外环占比"
              titlePosition="singleLine"
              :sliderMax="100"
              suffix="%"
            />
          </div>
        </template>
      </el-collapse-item>
    </el-collapse>
    <chart-common-options-setting :initCollapse="[]" :options="options" :ids="ids"></chart-common-options-setting>
    <el-dialog title="说明" :append-to-body="true" :visible.sync="explainDialog" custom-class="explainDialog">
      <p class="fs14 tips">
        <span>{{ explainTitle }}：</span>{{ explainTips }}
      </p>
      <div class="box">
        <img :src="explainImgSrc" v-if="explainImgSrc" alt="" class="img" />
        <video :src="explainVideoSrc" controls v-if="explainVideoSrc"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import legendSetting from "toolbarComponents/bigScreen/common/options/legendSetting"
import ChartCommonOptionsSetting from "toolbarComponents/bigScreen/common/chart-common-options-setting"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
import RadarSeriesSetting from "toolbarComponents/bigScreen/common/options/seriesSetting/radarSeriesSetting"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
import numberSetting from "toolbarComponents/bigScreen/common/options/numberSetting"
import Vector from "assets/images/Vector.png"

import publicData from "toolbarComponents/bigScreen/common/options/publicData"

export default {
  name: "radar-options-setting",
  components: {
    ChartCommonOptionsSetting,
    ChartCommonOptionsSetting1,
    RadarSeriesSetting,
    controlWidthAndSizeAndZindex,
    legendSetting,
    numberSetting,
  },
  mixins: [publicData],
  props: { options: Object },
  data() {
    return {
      this1: this,
      Vector,
      baseCollapse: [],
      activeNames: ["1", "2", "3", "6"],
      collapseActiveNames: ["1", "2", "3", "6"],
      allCollapseNames: ["4", "5"],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      labelTypeList: [
        {
          title: "数据标题",
          value: "{b}"
        },
        {
          title: "百分比",
          value: "{d}%"
        },
        {
          title: "数据标题+百分比",
          value: "{b}:{d}%"
        },
        {
          title: "数值+百分比",
          value: "{c}:{d}%"
        },
        {
          title: "数据标题+数值",
          value: "{b}:{c}"
        }
      ],
      tabsActive: 0, //  显示数据组还是图例
      collapse: {}, // 用来存放当前数据组和图例设置里面的展开收起状态
      labelSelectOptions: [
        {
          label: "样式1",
          value: 111
        },
        {
          label: "样式2",
          value: 222
        }
      ],
      shapeStyleList: [
        {
          title: "多边形",
          value: "polygon"
        },
        {
          title: "圆形",
          value: "circle"
        }
      ],
      explainDialog: false,
      explainTips: "",
      explainTitle: "",
      explainImgSrc: "",
      explainVideoSrc: "",
    }
  },
  created() {
    // 图表类组件兼容以前老数据，没有seriesTempAttributes属性的数据
    if (!this.options.chartOption.seriesTempAttributes) {
      const seriesTempAttributes = {
        // 用于存放数据中的通用配置项
        coordinateType: "" //没有坐标系
      }
      this.$changeOptionsEV(seriesTempAttributes, "chartOption.seriesTempAttributes", false)
    }
    // this.getOptionsHandle()
    this.options.chartOption.series.forEach(item => {
      this.collapse[item.name] = {
        isActive: false,
        shape_isActive: false,
        text_isActive: false
      }
    })
  },
  watch: {
    seriesDataLength(newVal, oldVal) {
      this.options.chartOption.series[0].data.forEach(item => {
        this.collapse[item.name] = {
          isActive: false,
          shape_isActive: false,
          text_isActive: false
        }
      })
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    seriesDataLength: {
      get() {
        if (this.options.chartOption.series[0].data) {
          return this.options.chartOption.series[0].data.length
        }
      }
    },
    chartOpt() {
      return this.options.chartOption
    },
    // 动态数据
    seriesData: {
      get() {
        if (this.options.chartOption.series[0].data) {
          return this.options.chartOption.series[0].data
        }
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.series[0].data = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    splitWidth: {
      get() {
        return this.hasProperty(this.chartOpt, "series.0.itemStyle.borderWidth")
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.series.0.itemStyle.borderWidth", false)
      }
    },
    splitColor: {
      get() {
        return this.hasProperty(this.chartOpt, "series.0.itemStyle.borderColor")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series.0.itemStyle.borderColor", false)
      }
    },
    axisFontFamily: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisName.fontFamily")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.fontFamily", false)
        this.formatterFunc()
      }
    },
    axisFontColor: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisName.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.color", false)
        this.formatterFunc()
      }
    },
    axisFontWeight: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisName.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.fontWeight", false)
        this.formatterFunc()
      }
    },
    axisFontSize: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisName.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.fontSize", false)
        this.formatterFunc()
      }
    },
    axisNameGap: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisNameGap")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisNameGap", false)
      }
    },
    axisLineColor: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisLine.lineStyle.color", false)
      }
    },
    axisLineWidth: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.axisLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisLine.lineStyle.width", false)
      }
    },
    splitShow: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.splitLine.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitLine.show", false)
      }
    },
    splitLineWidth: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.splitLine.lineStyle.width")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitLine.lineStyle.width", false)
      }
    },
    splitLineColor: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.splitLine.lineStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitLine.lineStyle.color", false)
      }
    },
    splitLineType: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.splitLine.lineStyle.type")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitLine.lineStyle.type", false)
      }
    },
    shape: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.shape")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.shape", false)
      }
    },
    splitAreaShow: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.splitArea.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitArea.show", false)
      }
    },
    splitNumber: {
      get() {
        return this.hasProperty(this.options.chartOption, "radar.splitNumber")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitNumber", false)
      }
    },
    areaColorList: {
      get() {
        // console.log(this.hasProperty(this.options.chartOption, "radar.splitArea.area"))
        return this.hasProperty(this.options.chartOption, "radar.splitArea.areaStyle.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.splitArea.areaStyle.color", false)
      }
    },
    labelSelectData: {
      get() {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        return pluginName.indexOf("labelFormaterStringToFuncPlugin") > -1 ? 2 : 1
      },
      set(val) {
        let pluginName = this.options.chartOption.hasOwnProperty("pluginName")
          ? this.options.chartOption.pluginName
          : []
        if (val === 1) {
          //样式1不要插件
          let index = pluginName.indexOf("labelFormaterStringToFuncPlugin")
          pluginName.splice(index, 1)
          this.$changeOptionsEV(null, "chartOption.series.0.labelLayout", false)
        } else if (val === 2) {
          //样式2带插件
          pluginName.push("labelFormaterStringToFuncPlugin")
        }
        this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
      }
    },

    centerTop: {
      get() {
        return parseInt(this.hasProperty(this.chartOpt, "series.0.center.0"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.0.center.0", false)
      }
    },
    centerLeft: {
      get() {
        return parseInt(this.hasProperty(this.chartOpt, "series.0.center.1"))
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "chartOption.series.0.center.1", false)
      }
    },

    radius1: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.options.chartOption, "radar.radius.0", "radius1", "0%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.radar.radius.0", false)
      }
    },
    radius2: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.options.chartOption, "radar.radius.1", "radius2", "75%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.radar.radius.1", false)
      }
    },
    position1: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.options.chartOption, "radar.center.0", "position1", "50%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.radar.center.0", false)
      }
    },
    position2: {
      get() {
        return parseInt(this.checkAndSetPrimaryVal(this.options.chartOption, "radar.center.1", "position2", "50%"))
      },
      set(newVal) {
        if (newVal !== newVal) {
          // 某种情况下会操作出NaN的情况
          return
        }
        this.$changeOptionsEV(newVal + "%", "chartOption.radar.center.1", false)
      }
    },
    showMaxLabel: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radar.axisName.showMaxLabel", "radar.axisName.showMaxLabel", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.showMaxLabel", false)
        if(!newVal){
          this.$changeOptionsEV("【{value}】", "chartOption.radar.axisName.formatter", false)
          this.$changeOptionsEV("", "chartOption.radar.axisName.rich", false)
        }else{
          this.formatterFunc()
        }
      }
    },
    maxLabelFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radar.axisName.maxLabelFontFamily", "radar.axisName.maxLabelFontFamily", 'sans-serif')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.maxLabelFontFamily", false)
        this.formatterFunc()
      }
    },
    maxLabelFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radar.axisName.maxLabelFontColor", "radar.axisName.maxLabelFontColor", 'rgba(255, 255, 255, 0.8)')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.maxLabelFontColor", false)
        this.formatterFunc()
      }
    },
    maxLabelFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radar.axisName.maxLabelFontWeight", "radar.axisName.maxLabelFontWeight", 'normal')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.maxLabelFontWeight", false)
        this.formatterFunc()
      }
    },
    maxLabelFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radar.axisName.maxLabelFontSize", "radar.axisName.maxLabelFontSize", 14)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.maxLabelFontSize", false)
        this.formatterFunc()
      }
    },
    maxLabelUnit: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "radar.axisName.maxLabelUnit", "radar.axisName.maxLabelUnit", '')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.radar.axisName.maxLabelUnit", false)
        this.formatterFunc()
      }
    }
  },
  methods: {
    // 切换当前tab激活项
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    stopChangePosition(rich, key, e) {
      const color = JSON.parse(e.dataTransfer.getData("dragRank"))
      const index = JSON.parse(e.dataTransfer.getData("dragKey"))
      this.areaColorList.splice(key, 1, color)
      this.areaColorList.splice(index, 1, rich)
    },
    startChangePosition(rich, key, e) {
      e.dataTransfer.setData("dragRank", JSON.stringify(rich))
      e.dataTransfer.setData("dragKey", JSON.stringify(key))
    },
    delRchSingleColor(rich, key) {
      this.areaColorList.splice(key, 1)
    },
    addAreaColor() {
      const color = "rgba(200,200,200,0.3)"
      this.areaColorList.push(color)
    },
    changeRichColor(rich, index, newColor) {
      this.areaColorList.splice(index, 1, newColor)
    },

    formatterFunc(){
      if(this.showMaxLabel){
        this.chartOpt.radar.axisName.rich = {
          a: {
            fontFamily: this.axisFontFamily,
            color: this.axisFontColor,
            fontWeight: this.axisFontWeight,
            fontSize: this.axisFontSize,
          },
          b: {
            fontFamily: this.maxLabelFontFamily,
            color: this.maxLabelFontColor,
            fontWeight: this.maxLabelFontWeight,
            fontSize: this.maxLabelFontSize,
            padding: [10,0]
          },
        }
        this.chartOpt.radar.axisName.formatter = (value, indicator) => {
          return [
            '{a|'+value+'}',
            '{b|'+indicator.max + ' ' + this.maxLabelUnit + '}',
          ].join('\n');
        }
      }
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTitle = "角度轴"
          this.explainTips = "用于设置雷达图的角度轴文本样式和轴线样式"
          this.explainVideoSrc = ""
          this.explainImgSrc = require("../../../../assets/images/tipsVideoImg/radar.png")
          break
        default:
      }
    },
  },
  mounted() {
    this.$collapseControl({
      activeNames: this.activeNames,
      collapseActiveNames: this.collapseActiveNames,
      allCollapseNames: this.allCollapseNames
    })
  }
}
</script>

<style scoped>
.inlineMiddle {
  display: inline-block;
  vertical-align: middle;
}

.percent100 {
  width: 100%;
}

.height32 {
  height: 32px;
  line-height: 32px;
}

.percent38 {
  width: 38%;
}

.percent72 {
  width: 72%;
}

.height4 {
  height: 4px;
}

.color-picker-container .color-text {
  line-height: 20px;
  display: inline-block;
  vertical-align: top;
  color: inherit;
  font-size: 12px;
  max-width: 60px;
}

.percent80.color-text {
  max-width: 80%;
}

.percent100_80 {
  width: calc(100% - 80px);
}

.item-title-box {
  width: calc(100% - 40px);
  justify-content: space-between;
}

.setting-item .list-label {
  line-height: 32px;
}

.percent42 {
  width: 42%;
}

.percent58 {
  width: calc(58% - 8px);
}

.percent58_60 {
  width: calc(58% - 60px);
}

.radar-options-setting-dialog /deep/ .el-collapse-item__header {
  min-height: 48px;
  height: auto;
}

.percent65_ {
  width: calc(100% - 65px);
}
.area-add-icon {
  float: right;
  cursor: pointer;
}
.percent65 {
  width: 65%;
}
.fr {
  float: right;
}
.single_color_icons {
  position: relative;
}
.move-icon {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 1px;
}

.del-icon {
  cursor: pointer;
  position: absolute;
  right: 30px;
  top: 4px;
}
.percent78 {
  width: 78%;
}
</style>
<style>
.number-input-box {
  position: relative;
  display: inline-block;
}

.number-input-box .el-input-number .el-input__inner {
  padding-right: 30px;
  text-align: left;
}
.number-input-box .suffix_text {
  position: absolute;
  top: 0;
  line-height: 32px;
  right: 0;
}
.radar-options-setting-dialog .tabs .tabs-item {
  font-weight: 600;
  font-size: 14px;
  line-height: 48px;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  margin-right: 24px;
}
.radar-options-setting-dialog .tabs.home_tabs .tabs-item {
  color: rgba(0, 0, 0, 0.6);
}
.radar-options-setting-dialog .tabs .tabs-item.active {
  color: var(--themeColor);
  border-bottom: 2px solid;
}
</style>
